import * as React from 'react'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { EnvironmentSelectorState } from '../../../../../common/environment/reducer'
import { ResourceSelectorState } from '../../../../../common/resource/reducer'
import { ARMHybridDetail, ARMServer, User } from '../../../../../remote-api/models'
import { Profile } from '../../../../../remote-api/CoreServicesRemoteApi'
import { BasicAlert } from '../../../model'
import BasicAlertModalConfigurations from './BasicAlertModalConfigurations/BasicAlertModalConfigurations'
// import BasicAlertModalPerformance from './BasicAlertModalPerformance/BasicAlertModalPerformance'
// import TabPanel from '@mulesoft/anypoint-components/lib/TabPanel'
// import TabList from '@mulesoft/anypoint-components/lib/TabList'
// import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
// import Tabs from '@mulesoft/anypoint-components/lib/Tabs'
// import Tab from '@mulesoft/anypoint-components/lib/Tab'
import './BasicAlertModalBody.css'
import { VersionSelectorState } from '../../../../../common/version/reducer'

export type ValueProps = {
  organizationId: string
  existingAlert?: BasicAlert
  servers: ARMServer[]
  serversLoading: boolean
  environmentSelector: EnvironmentSelectorState
  resourceSelector: ResourceSelectorState
  versionSelector: VersionSelectorState
  serverApplications?: ARMHybridDetail[]
  profile?: Profile
  users: User[]
  emailTemplateEnabled: boolean
  apiAlertsEnabled: boolean
  apiResponseCodesLimit: number
  hasEditRole?: boolean
  isBasicAlertsLimitExceeded: boolean
}

export type EventProps = {
  load: (envId?: string, resourceId?: string, versionId?: string, targetId?: string) => void
  fetchUsers: (search: string, limit: number, offset: number) => Promise<{ data: User[] }>
  changeUsers: (users: User[]) => void
  environmentSelected: (environmentId: string) => void
  resourceSelected: (resourceId: string, resourceType: ResourceType) => void
  versionSelected: (versionId: string) => void
  saveBasicAlert: (alert: BasicAlert) => void
  deleteBasicAlert: (alert: BasicAlert) => void
  handleClose: () => void
  cleanResourcesSelectors: () => void
}

export type Props = ValueProps & EventProps

export default class BasicAlertModalBody extends React.Component<Props> {

  constructor(props: Props) {
    super(props)

    this.getConfigurationsProps = this.getConfigurationsProps.bind(this)
    // this.getPerformanceProps = this.getPerformanceProps.bind(this)
  }

  getConfigurationsProps() {
    return {
      organizationId: this.props.organizationId,
      existingAlert: this.props.existingAlert,
      servers: this.props.servers,
      serversLoading: this.props.serversLoading,
      environmentSelector: this.props.environmentSelector,
      resourceSelector: this.props.resourceSelector,
      versionSelector: this.props.versionSelector,
      profile: this.props.profile,
      users: this.props.users,
      emailTemplateEnabled: this.props.emailTemplateEnabled,
      apiAlertsEnabled: this.props.apiAlertsEnabled,
      apiResponseCodesLimit: this.props.apiResponseCodesLimit,
      hasEditRole: this.props.hasEditRole,
      isBasicAlertsLimitExceeded: this.props.isBasicAlertsLimitExceeded,
      load: this.props.load,
      fetchUsers: this.props.fetchUsers,
      changeUsers: this.props.changeUsers,
      environmentSelected: this.props.environmentSelected,
      resourceSelected: this.props.resourceSelected,
      versionSelected: this.props.versionSelected,
      saveBasicAlert: this.props.saveBasicAlert,
      deleteBasicAlert: this.props.deleteBasicAlert,
      handleClose: this.props.handleClose,
      cleanResourcesSelectors: this.props.cleanResourcesSelectors,
    }
  }

  // getPerformanceProps() {
  //   if (this.props.existingAlert) {
  //     return {
  //       existingAlert: this.props.existingAlert,
  //       serverApplications: this.props.serverApplications,
  //       profile: this.props.profile,
  //       handleClose: this.props.handleClose,
  //       deleteBasicAlert: this.props.deleteBasicAlert
  //     }
  //   }
  //   return undefined
  // }

  render() {
    const configurationsProps = this.getConfigurationsProps()
    // const {existingAlert} = this.props
    // const performanceProps = this.getPerformanceProps()

    return (
      <div className={'basic-alert-modal-body'}>
        <BasicAlertModalConfigurations {...configurationsProps}/>
        {/*{!existingAlert && <BasicAlertModalConfigurations {...configurationsProps}/>}*/}
        {/*{existingAlert && performanceProps && <div className={'existing-basic-alert-modal-body'}>*/}
          {/*<Tabs testId={'existing-basic-alert-modal-tabs'} type={'primary'}>*/}
            {/*<TabList testId={'existing-basic-alert-modal-tabs-list'}>*/}
              {/*<Tab testId={'existing-basic-alert-modal-performance-tab'}>*/}
                {/*<IconPanel name={'metrics'} fill={'#3A3B3C'} size={14} testId="existing-basic-alert-modal-performance-tab-icon"/>*/}
                {/*<span>Performance</span>*/}
              {/*</Tab>*/}
              {/*<Tab testId={'existing-basic-alert-modal-configurations-tab'}>*/}
                {/*<IconPanel name={'settings'} fill={'#3A3B3C'} size={14} testId="existing-basic-alert-modal-configurations-tab-icon"/>*/}
                {/*<span>Configurations</span>*/}
              {/*</Tab>*/}
            {/*</TabList>*/}

            {/*<TabPanel testId={'existing-basic-alert-modal-performance'}><BasicAlertModalPerformance {...performanceProps}/></TabPanel>*/}
            {/*<TabPanel testId={'existing-basic-alert-modal-configurations'}><BasicAlertModalConfigurations {...configurationsProps}/></TabPanel>*/}
          {/*</Tabs>*/}
        {/*</div>}*/}
      </div>
    )
  }

}
